<template>
  <div class="image-detail">
    <span v-if="wsStatus" style="margin-left:10px;">{{ wsStatus }}</span>
    <header class="detail-header">
      <button @click="goBack" class="back-btn">← 돌아가기</button>
      <h1>이미지 분석</h1>
      <div class="header-actions">
        <!-- === 카메라 선택 === -->
          <label class="text-sm font-medium">카메라 선택</label>
          <div class="flex gap-2 items-center mb-3">
            <select v-model="selectedDeviceId" class="border rounded px-2 py-1 w-full">
              <option v-for="d in devices" :key="d.deviceId" :value="d.deviceId">
                {{ d.label || 'Camera' }}
              </option>
            </select>
            <button
              class="px-3 py-2 bg-gray-100 rounded"
              @click="restartWithDevice"
              :disabled="!selectedDeviceId"
            >
              변경
            </button>
          </div>
          <!-- === /카메라 선택 === -->

        <div
          class="ws-indicator"
          :class="{ on: wsConnected }"
          :title="wsConnected ? '서버 연결됨' : '서버 해제됨'"
        >
          <span class="dot"></span>
          <span class="label">{{ wsConnected ? '연결됨' : '해제됨' }}</span>
        </div>
        <button
          @click="wsConnected ? disconnectFromServer() : connectToServer()"
          class="connect-btn"
        >
          {{ wsConnected ? '연결 해제' : '서버 연결' }}
        </button>
      </div>
    </header>

    <main class="detail-content">
      <!-- 좌측: 이미지 영역 -->
      <div class="text-section">
        <div class="text-container">
            <div class="text-wrapper">
            <!-- 이미지 대신 텍스트 -->
            <p class="main-text"></p>
            </div>

            <div class="input-group" style="display:flex; gap:8px;">
            <input
              v-model="tx"
              type="text"
              placeholder="여기에 QA를 입력하세요"
              @keyup.enter="handleQAUpload"
              style="flex:1;padding:8px 10px;border:1px solid #ddd;border-radius:8px;"
            >
            <button
              @click="handleQAUpload"
              :disabled="!(tx && typeof tx === 'string' && tx.trim())"
              style="padding:8px 12px;border:1px solid #ddd;border-radius:8px;cursor:pointer;"
            >
              실행
            </button>

          </div>
            <!-- TextData 상세 정보 -->
            <div class="textdata-details">
            <h4>📋 텍스트 정보</h4>
            <div class="info-grid">
                <div class="info-item">
                <strong>텍스트:</strong> {{ textData.text }}
                </div>
                <div class="info-item">
                <strong>Rag 정보:</strong> {{ textData.id || '없음' }}
                  <button
                    v-if="textData.id"
                    @click="playRagIdTTS"
                    class="tts-btn"
                    style="margin-left:6px"
                  >
                    🔊 읽어주기
                  </button>
              </div>

                
            </div>
            </div>
        </div>
        </div>


      <!-- 우측: 분석 및 대화 영역 -->
      <div class="analysis-section">
        <!-- 이미지 분석 결과 -->
        <div class="analysis-panel">
        <!--
          <h3>📊 이미지 분석 결과</h3>
          -->
          
          <!-- TTS 속도 선택 + 모델 선택 좌우배치 컨테이너 -->
          <div class="controls-horizontal-container">
            <!-- TTS 속도 선택 영역 -->
            <div class="tts-rate-wrapper">
              <h4 class="tts-rate-title">🔊 음성 속도 설정</h4>
              <div class="tts-rate-container">
                <div class="rate-label">속도:</div>
                <div class="rate-buttons-wrapper">
                  <button 
                    v-for="num in [2,5,8,12,15]" 
                    :key="num"
                    class="rate-btn"
                    :class="{ active: rate === num }"
                    @click="selectRate(num)"
                  >
                    {{ num }}x
                  </button>
                </div>
              </div>
            </div>
            
            <!-- 모델 선택 영역 -->
            <div class="model-selection-wrapper">
              <h4 class="model-selection-title">🤖 모델 선택</h4>
              <div class="model-toggle-container">
                <div class="toggle-label">Model Type:</div>
                <div class="toggle-switch-wrapper">
                  <button 
                    class="toggle-option"
                    :class="{ active: ours }"
                    @click="selectOurs"
                  >
                    Ours
                  </button>
                  <button 
                    class="toggle-option"
                    :class="{ active: !ours }"
                    @click="selectBaseline"
                  >
                    Baseline
                  </button>
                </div>
              </div>
            </div>
          </div>

                  
          <div class="analysis-content">
            <div v-if="analysisLoading" class="loading">
              분석 중...
            </div>
            <div v-else class="analysis-results">
              
              <!-- 분석 결과 표시 -->
              <div v-if="textData.isAnalyzed && textData.analyzed" class="ai-analysis">
                <h4>🤖 AI 분석 결과</h4>
                <button @click="playAnalysisTTS" class="tts-btn">
                  🔊 읽어주기
                </button>
                <div class="analysis-json-container">
                  <button @click="toggleJsonExpanded" class="json-toggle-btn">
                    {{ jsonExpanded ? '접기' : '전체 보기' }}
                  </button>
                  <pre class="analysis-json" :class="{ expanded: jsonExpanded }">{{ formatAnalysisData(textData.analyzed) }}</pre>
                </div>
              </div>
              
              <!-- 기존 분석 결과 (호환성) -->
              <div v-if="detectedObjects.length > 0" class="analysis-item">
                <strong>감지된 객체:</strong>
                <ul>
                  <li v-for="object in detectedObjects" :key="object">{{ object }}</li>
                </ul>
              </div>
              <div v-if="dominantColors.length > 0" class="analysis-item">
                <strong>색상 분석:</strong>
                <div class="color-palette">
                  <div 
                    v-for="color in dominantColors" 
                    :key="color"
                    class="color-swatch"
                    :style="{ backgroundColor: color }"
                    :title="color"
                  ></div>
                </div>
              </div>
              <div v-if="imageCharacteristics" class="analysis-item">
                <strong>특성 분석:</strong>
                <p>{{ imageCharacteristics }}
                  <button v-if="imageCharacteristics" @click="playAnalysisTTS" class="tts-btn">🔊</button>
                </p>
              </div>
            </div>
          </div>

          <!-- === WS 스트림 / ROI 미리보기 === -->
          <div class="ws-row">
            <div class="ws-col">
              <h4 class="ws-title">🎥 실시간 스트림</h4>
              <div class="ws-frame">
                <img v-if="wsFrameSrc" :src="wsFrameSrc" class="ws-img" alt="stream" />
                <div v-else class="ws-empty">스트림 대기중…</div>
                <div class="ws-fps">FPS: {{ wsFps }}</div>
              </div>
              <div class="ws-stats">
                <span>연결: <b>{{ wsConnected ? '✅' : '❌' }}</b></span>
                <span>서버프레임: {{ wsServerFrame }}</span>
                <span>ArUco: {{ wsAruco ? '✅' : '❌' }}</span>
                <span>손: {{ wsHand ? '✅' : '❌' }}</span>
              </div>
            </div>

            <div class="ws-col">
              <h4 class="ws-title">📸 저장된 ROI</h4>
              <div class="ws-frame">
                <img v-if="wsSavedRoiSrc" :src="wsSavedRoiSrc" class="ws-img" alt="roi" />
                <div v-else class="ws-empty">아직 저장된 ROI 없음</div>
              </div>
              <div class="ws-stats">
                <span>상태: {{ wsSaveStatus }}</span>
                <span v-if="wsSavedRoiSize">크기: {{ wsSavedRoiSize }}</span>
              </div>
              <div style="margin-top:8px; display:flex; gap:8px; align-items:center; flex-wrap:wrap;">
                <button class="status-btn" @click="sendTipToApi(wsSavedRoiSrc)" :disabled="!wsSavedRoiSrc || apiSending">
                  {{ apiSending ? '전송 중...' : 'API로 전송' }}
                </button>
                <span v-if="apiResult" style="color:#2d5016;">✅ {{ apiResult }}</span>
                <span v-if="apiError" style="color:#c62828;">❌ {{ apiError }}</span>
              </div>
            </div>
          </div>
          <!-- === /WS 스트림 / ROI 미리보기 === -->


        </div>

        <!-- 대화 창 -->
        <div class="chat-panel">
          <div class="chat-panel-header">
            <h3>💬 이미지에 대해 질문하기</h3>
            <button @click="toggleTTS" class="tts-toggle-btn">
              {{ ttsEnabled ? '🔇 음성 Off 🔇' : '🔊 음성 On 🔊' }}
            </button>
          </div>
          
          <!-- 추천 질문을 상단으로 이동 -->
          <!--
          <div class="suggested-questions">
            <p>추천 질문:</p>
            <div class="suggested-questions-container">
              <button 
                v-for="question in suggestedQuestions" 
                :key="question"
                @click="askQuestion(question)"
                class="suggestion-btn"
              >
                {{ question }}
              </button>
            </div>
          </div>
          -->
          
          <div v-if="isListening" class="stt-indicator">🎤 음성 인식 중... (Ctrl+Shift를 떼면 음성 인식이 완료됩니다)</div>
          <div v-else class="stt-indicator">Ctrl+Shift를 누르면 음성 인식이 시작됩니다</div>
          <div v-if="sttError" class="error">{{ sttError }}</div>
          <div class="chat-messages" ref="chatMessages">
            <div v-if="chatMessages.length === 0" class="empty-chat-message">
              👋 안녕하세요! 이미지에 대해 궁금한 것을 질문해보세요.<br>
            </div>
            <div 
              v-for="message in chatMessages" 
              :key="message.id"
              :class="['message', message.type]"
            >
              <div class="message-content">
                {{ message.content }}
                <button v-if="message.type === 'assistant' && message.content" @click="playChatTTS(message)" class="tts-btn">🔊</button>
              </div>
              <div class="message-time">
                {{ formatTime(message.timestamp) }}
              </div>
            </div>
          </div>
          
          <div class="chat-input-area">
            <div class="input-container">
              <input
                v-model="currentMessage"
                @keyup.enter="sendMessage"
                placeholder="이미지에 대해 질문해보세요..."
                class="chat-input"
                :disabled="chatLoading"
              >
              <button 
                @click="sendMessage" 
                class="send-btn"
                :disabled="!currentMessage.trim() || chatLoading"
              >
                <span v-if="chatLoading">...</span>
                <span v-else>전송</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
// --- Imports (aligned with ImageDetail.vue baseline) ---
// import { generateImageCaption, generateVLMChatResponse, speakText } from '@/js/VLM.js';
import { generateImageCaption, speakText, stopSpeaking, UserQA, skipSentence, replayPrevious, togglePlayPause } from '@/js/VLM.js';
import ApiService from '@/services/ApiService';
import { DotpadList } from '@/js/dot/DotpadList.js';
import { dotpadState, dotpadTTS, dotpadwebCam } from '@/js/dot/Dotpad.js';
import WhisperService from '@/services/WhisperService.js';
import { connectWS, onWS, sendJSON, isOpen, disconnectWS } from '@/socket/socket.js';
import thinkingSndUrl from '@/assets/sound/thinking.mp3';
import doneSndUrl from '@/assets/sound/done.mp3'; // mp3여도 OK

let labels = [];
let assistant_result = "";

export default {
  name: 'QADetail',
  props: { id: { type: String, required: true } },

  data() {
    return {
      // === QA 입력/상태 ===
      textData: {
        id: '',
        rId: '',
        objectType: '',
        file: '',
        name: '',
        size: null,
        data: null,
        isUploaded: false,
        isAnalyzed: false,
        analyzed: null,
        ctrlDown: false,
        shiftDown: false,
        text: ''
      },

      // === UI state ===
      analysisLoading: false,
      chatLoading: false,
      currentMessage: '',
      chatMessages: [],
      detectedObjects: [],
      dominantColors: [],
      imageCharacteristics: '',
      suggestedQuestions: [
        '이 텍스트의 핵심은 무엇인가요?',
        '중요한 수치/사실을 알려주세요.',
        'STEM 교육에서 어떻게 활용할 수 있나요?',
        '요약과 함께 후속 질문을 제안해 주세요.'
      ],
      messageIdCounter: 0,
      jsonExpanded: false,

      // === STT ===
      isListening: false,
      streamController: null,
      transcription: '',
      realTimeResults: [],
      sttError: null,
      isInitializing: false,

      // === TTS / 모드 ===
      ttsEnabled: true,
      rate: 5,
      ours: true,

      // === Timers ===
      elapsed0Ms: 0, timer0Running: false, timer0Interval: null, started0At: null,
      elapsed1Ms: 0, timer1Running: false, timer1Interval: null, started1At: null,
      elapsed2Ms: 0, timer2Running: false, timer2Interval: null, started2At: null,

      // === Dotpad ===
      legend: [],
      chart: [],
      currentDotpadState: '1',
      currentDotpadTTS: '',
      currentDotpadwebCam: false,

      // === WS ===
      wsConnected: false,
      wsStatus: '',
      wsFrameSrc: '',
      wsServerFrame: 0,
      wsAruco: false,
      wsHand: false,
      wsSaveStatus: '대기 중',
      wsSavedRoiSrc: '',
      wsSavedRoiSize: '', // string like "640 x 480px" (ApiService can parse)
      wsFps: 0,
      wsLastRoiSig: '',
      wsLastTipSig: '',

      // === API flags ===
      apiSending: false,
      apiResult: '',
      apiError: '',
      apiSendingTip: false,
      apiErrorTip: '',
      apiResultTip: '',

      // Tip/ROI pairing (윈도우 기반)
      lastSaveRoiAt: 0, // save_roi 요청 시각(ms)
      roiReadyAt: 0,    // ROI 이미지 준비 시각(ms)
      pendingTip: null, // ROI 준비 전에 도착한 tip 보관

      // === Devices ===
      devices: [],
      selectedDeviceId: '',
      stream: null,
      streamReady: false,

      // === Audio ===
      thinkingAudio: null,
      doneAudio: null,
      _audioUnlocked: false,
      _fadeRAF: null,
      _fadeToken: 0,

      _keyOpts: { capture: true, passive: false }
    };
  },

  created() {
    this.loadTextData();
    this.loadOursBaselineState();
    this.loadRateState();

    const v = this.$route.query.ours_or_baseline;
    if (v !== undefined) {
      this.ours = (v === '1' || v === 'true' || v === true);
      this.$nextTick(() => (this.ours ? this.selectOurs() : this.selectBaseline()));
    }
  },

  async mounted() {
    // Dotpad state sync + listeners
    this.printPixels();
    window.addEventListener('dotpad-state-changed', this.onDotpadStateChanged, { passive: true });
    window.addEventListener('dotpad-TTS-changed', this.onDotpadTTSChanged, { passive: false });
    window.addEventListener('dotpad-webCam-changed', this.onDotpadwebCamChanged, { passive: false });
    this.currentDotpadState = dotpadState;
    this.currentDotpadTTS = dotpadTTS;
    this.currentDotpadwebCam = dotpadwebCam;

    // Audio init (match ImageDetail): start muted/0.0, fade in when thinking
    this.thinkingAudio = new Audio(thinkingSndUrl);
    this.thinkingAudio.loop = true;
    this.thinkingAudio.volume = 0.0;

    this.doneAudio = new Audio(doneSndUrl);
    this.doneAudio.volume = 0.18;

    // Unlock audio on user gesture
    const unlock = () => {
      if (this._audioUnlocked) return;
      this._audioUnlocked = true;
      this.thinkingAudio.muted = false;
      this.doneAudio.muted = false;
      this.doneAudio.play().then(() => this.doneAudio.pause()).catch(() => {});
      if (this.isThinking) this.startThinkingSound();
      window.removeEventListener('pointerdown', unlock);
      window.removeEventListener('keydown', unlock);
    };
    window.addEventListener('pointerdown', unlock, { once: true, passive: true });
    window.addEventListener('keydown', unlock, { once: true });

    // Start QA analysis (single call — removed duplicate)
    this.processAnalysisData();

    // If already thinking, ensure loop starts
    if (this.isThinking) this.startThinkingSound();

    // Whisper init
    try {
      this.isInitializing = true;
      await WhisperService.initialize();
      console.log('✅ Whisper 모델 초기화 완료');
    } catch (error) {
      console.error('❌ Whisper 모델 초기화 실패:', error);
      this.sttError = 'Whisper 모델 초기화 실패: ' + error.message;
    } finally {
      this.isInitializing = false;
    }

    // Hotkeys
    window.addEventListener('keydown', this.handleCtrlShiftDown);
    window.addEventListener('keyup', this.handleCtrlShiftUp);
    window.addEventListener('keydown', this.handleTTSShortcuts, this._keyOpts);
    window.__imageDetailHotkeysBound__ = true;

    // Devices
    if (!navigator?.mediaDevices?.getUserMedia) {
      console.warn('이 브라우저는 카메라 API를 지원하지 않습니다.');
    } else {
      await this.refreshDevices();
      this._deviceChangeHandler = this.refreshDevices;
      navigator.mediaDevices.addEventListener('devicechange', this._deviceChangeHandler);
    }

    // WS message handler registration (do not auto-connect)
    onWS('open', this.handleWSOpen);
    onWS('close', this.handleWSClose);

    let cnt = 0, last = Date.now();
    onWS('message', (data) => {
      if (data?.type !== 'frame') return;

      this.wsFrameSrc = 'data:image/jpeg;base64,' + data.image;
      this.wsServerFrame = data.frame_count || 0;
      this.wsAruco = !!data.aruco_detected;
      this.wsHand = !!data.hand_detected;

      if (data.save_result) {
        this.wsSaveStatus = data.save_result;
        setTimeout(() => { this.wsSaveStatus = '대기 중'; }, 3000);
      }

      // ROI 이미지 수신
      if (data.saved_image) {
        this.wsSavedRoiSrc = 'data:image/png;base64,' + data.saved_image;

        const probe = new Image();
        probe.onload = () => {
          this.wsSavedRoiSize = { width: probe.width, height: probe.height };
          this.roiReadyAt = Date.now();

          // save_roi 윈도우(3s) 내 + 보류 tip 있으면 전송
          const withinWindow = (this.roiReadyAt - this.lastSaveRoiAt) <= 3000;
          if (withinWindow && this.pendingTip) {
            const tip = this.pendingTip;
            this.pendingTip = null;
            this._sendTipIfNotDup(tip);
          }
        };
        probe.src = this.wsSavedRoiSrc;
      }

      // Tip 좌표 수신: save_roi 윈도우(3s) 내 + ROI 준비됨 조건에서만 전송
      if (data.saved_tip_roi) {
        const tip = Array.isArray(data.saved_tip_roi) && data.saved_tip_roi.length === 2
          ? data.saved_tip_roi
          : (typeof data.saved_tip_roi === 'object' ? [data.saved_tip_roi.x, data.saved_tip_roi.y] : null);

        if (!tip || !Number.isFinite(tip[0]) || !Number.isFinite(tip[1])) return;

        const nowMs = Date.now();
        const withinWindow = (nowMs - this.lastSaveRoiAt) <= 3000; // 3s
        const roiReady = this.wsSavedRoiSize && this.wsSavedRoiSize.width;

        if (!withinWindow) {
          // 창 밖 → 무시
          return;
        }
        if (!roiReady) {
          // ROI 아직이면 보류
          this.pendingTip = tip;
        } else {
          this._sendTipIfNotDup(tip);
        }
      }

      const now = Date.now();
      if (++cnt && now - last >= 1000) { this.wsFps = cnt; cnt = 0; last = now; }
    });

    window.addEventListener('keydown', this.handleArrowDownWS, this._keyOpts);
  },

  beforeUnmount() {
    // Stop audio/TTS
    try {
      if (this._fadeRAF) cancelAnimationFrame(this._fadeRAF);
      this._fadeRAF = null; this._fadeToken++;
      this.thinkingAudio?.pause();
      if (this.thinkingAudio) { this.thinkingAudio.currentTime = 0; this.thinkingAudio.volume = 0; }
      this.doneAudio?.pause();
      if (this.doneAudio) this.doneAudio.currentTime = 0;
      stopSpeaking();
    } catch {}

    window.removeEventListener('dotpad-state-changed', this.onDotpadStateChanged);
    window.removeEventListener('dotpad-TTS-changed', this.onDotpadTTSChanged);
    window.removeEventListener('dotpad-webCam-changed', this.onDotpadwebCamChanged);

    try { if (this._deviceChangeHandler) navigator.mediaDevices.removeEventListener('devicechange', this._deviceChangeHandler); } catch {}
    this.stopStream();

    window.removeEventListener('keydown', this.handleCtrlShiftDown);
    window.removeEventListener('keyup', this.handleCtrlShiftUp);
    window.removeEventListener('keydown', this.handleTTSShortcuts, this._keyOpts);
    window.__imageDetailHotkeysBound__ = false;

    if (this.timer0Interval) clearInterval(this.timer0Interval);
    if (this.timer1Interval) clearInterval(this.timer1Interval);
    if (this.timer2Interval) clearInterval(this.timer2Interval);

    disconnectWS();
  },

  computed: {
    imageUrl() { return this.textData.file || ''; },
    imageName() { return this.textData.name || '이미지'; },
    imageSize() { return this.textData.size || 0; },

    formattedTime0() { const s = Math.floor(this.elapsed0Ms / 1000); return `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`; },
    formattedTime1() { const s = Math.floor(this.elapsed1Ms / 1000); return `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`; },
    formattedTime2() { const s = Math.floor(this.elapsed2Ms / 1000); return `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`; },

    isThinking() {
      return !!(this.isInitializing || this.analysisLoading || this.chatLoading || this.apiSending || this.apiSendingTip);
    }
  },

  watch: {
    isThinking(val, oldVal) {
      if (val && !oldVal) this.startThinkingSound();
      if (!val && oldVal) this.stopThinkingSound(false); // play done via playDoneThenSpeak
    }
  },

  methods: {
    // === 공통 정리 ===
    cleanupAudioTTS() {
      try {
        if (this._fadeRAF) cancelAnimationFrame(this._fadeRAF);
        this._fadeRAF = null;
        this._fadeToken++;

        if (this.thinkingAudio) {
          this.thinkingAudio.pause();
          this.thinkingAudio.currentTime = 0;
          this.thinkingAudio.volume = 0;
        }
        if (this.doneAudio) {
          this.doneAudio.pause();
          this.doneAudio.currentTime = 0;
        }
        stopSpeaking();
      } catch {}
    },

    // === WS control ===
    connectToServer() { connectWS(); },
    disconnectFromServer() { disconnectWS(); },
    handleArrowDownWS(e) {
      if ((e.code === 'ArrowDown' || e.key === 'j' || e.key === 'J') && isOpen()) {
        e.preventDefault();
        this.lastSaveRoiAt = Date.now(); // 윈도우 시작
        sendJSON({ type: 'save_roi', timestamp: this.lastSaveRoiAt });
        this.wsSaveStatus = '저장 요청됨...';
      }
    },
    handleWSOpen() {
      this.wsConnected = true;
      // 연결 시 과거 상태 정리
      this.wsLastTipSig = '';
      this.wsSavedRoiSize = null;
      this.pendingTip = null;
      this.lastSaveRoiAt = 0;
      this.roiReadyAt = 0;
    },
    handleWSClose() { this.wsConnected = false; },

    // === Tip 전송 ===
    _sendTipIfNotDup(tip) {
      const sig = `${tip[0].toFixed(2)},${tip[1].toFixed(2)}`;
      if (sig === this.wsLastTipSig) return;
      this.wsLastTipSig = sig;
      this.sendTipToApi(tip);
    },

    async sendTipToApi(tip) {
      if (!tip || tip.length < 2) return;
      if (!this.wsSavedRoiSize || !this.wsSavedRoiSize.width) {
        this.pendingTip = tip; // ROI 아직이면 보류
        return;
      }

      this.apiSendingTip = true;
      this.apiErrorTip = '';
      this.apiResultTip = '';

      try {
        const res = await ApiService.sendFingerTip(tip, this.wsSavedRoiSize);

        console.log("res = await ApiService.sendFingerTip", res);
        var text = res['text'];
        var braille = res['braille'];

        // 채팅에 표시할 답변 텍스트 추출
        const answer =
          text?.text ||
          text?.message ||
          text?.answer ||
          (typeof text === 'string' ? text : '좌표 전송이 완료되었습니다.');

        this.addMessage('system', `손가락 좌표를 API로 전송했습니다: ${JSON.stringify(tip)}`);
        this.addMessage('assistant', answer);
        // 상단 상태 텍스트(선택)
        this.apiResultTip = typeof text === 'string' ? text : (text?.message || '전송 완료');
        this.translate(braille);
        
      } catch (e) {
        this.apiErrorTip = e?.message || String(e);
        this.addMessage('system', `손가락 좌표 전송 실패: ${this.apiErrorTip}`);
      } finally {
        this.apiSendingTip = false;
      }
    },

    // === Dotpad events ===
    onDotpadStateChanged(e) {
      this.currentDotpadState = (e?.detail?.state) || dotpadState;
      this.printPixels();
    },
    onDotpadTTSChanged(e) {
      this.currentDotpadTTS = (e?.detail?.tts) || dotpadTTS;
      switch (this.currentDotpadTTS) {
        case 'R': skipSentence(this.rate); break;
        case 'L': replayPrevious(this.rate); break;
        case 'S': togglePlayPause(this.rate); break;
        default: break;
      }
    },
    onDotpadwebCamChanged(e) {
      this.currentDotpadwebCam = (e?.detail?.webCam) || dotpadwebCam;
      if (this.currentDotpadwebCam) {
        this.lastSaveRoiAt = Date.now(); // 윈도우 시작
        sendJSON({ type: 'save_roi', timestamp: this.lastSaveRoiAt });
        this.wsSaveStatus = '저장 요청됨...';
      }
    },


    // === Braille text ===
    runTranslate() {
      const text = String(this.tx ?? "");
      this.out = typeof this.translate === 'function' ? this.translate(text) : text;
    },
    translate(text) {
      ApiService.translate(text).then(response => {
        let labels = response?.text || '';
        const dotpadList = DotpadList.getList();
        if (dotpadList.length > 0) {
          for (const dotPad of dotpadList) {
            const padHex = (data, totalLen) => data.padEnd(totalLen, '0');
            const filled = padHex(labels, 40);
            dotPad.dotpadSDK.dotPadSendModule.setDotPadLineCommand(0, '80', '00', filled);
            dotPad.dotpadSDK.dotPadSendModule.setRefreshMode('TEXT_DISPLAY');
            dotPad.dotpadSDK.dotPadSendModule.sendCommand();
          }
        }
      }).catch(error => { console.error('AI 요청 실패:', error); this.chatLoading = false; });
    },

    // === Dotpad pixels ===
    printPixels() {
      let pixels = [];
      const state = this.currentDotpadState ?? dotpadState;
      if (state === '1') pixels = this.legend; else if (state === '2') pixels = this.chart; else return;
      if (!Array.isArray(pixels) || pixels.length === 0) return;
      const dotpadList = DotpadList.getList();
      if (!Array.isArray(dotpadList) || dotpadList.length === 0) return;
      for (const dotPad of dotpadList) {
        try { dotPad.dotpadSDK.Load_mapFile(pixels); dotPad.dotpadSDK.Make_DTM_Data(); dotPad.dotpadSDK.sendPixelPattern(); }
        catch (err) { console.error('Dotpad 전송 오류:', err); }
      }
    },

    // === QA 분석 파이프라인 (printPixels → done → speak) ===
    async processAnalysisData() {
      if (!this.textData?.text) {
        console.warn('텍스트가 없어 QA 분석을 건너뜀.');
        return;
      }
      this.analysisLoading = true;
      try {
        const response = await ApiService.analyzeQA(this.textData.text, this.ours ? '1' : '0');
        labels = response?.resized_list || [];
        this.chart = Array.isArray(labels) ? this.flattenArray(labels, 60, 40) : [];
        this.legend = this.flattenArray(response?.legend || [], 60, 40);

        if (this.ours) { this.currentDotpadState = '1'; this.printPixels(); }
        this.textData.data = this.chart; 
        this.translate(response?.type);

        this.textData.isAnalyzed = true;
        this.textData.analyzed = response?.DS || '';
        this.textData.id = response?.rag || this.textData.id;
        
        await this.playDoneThenSpeak(this.textData.id + this.textData.analyzed);
      } catch (error) {
        console.error('❌ QA 분석 중 오류 발생:', error); 
        await this.playDoneThenSpeak("정보 추출에 실패 했습니다. 다시 시도해주세요.");
        this.imageCharacteristics = 'QA 분석 중 오류가 발생했습니다: ' + (error?.message || error);
        this.cleanupAudioTTS();
      } finally {
        this.analysisLoading = false;
      }
    },  
 
    // === Chat ===
    async sendMessage() {
      const userMessage = this.currentMessage.trim();
      if (!userMessage || this.chatLoading) return;
      this.currentMessage = '';
      this.addMessage('user', userMessage);
      this.chatLoading = true;

      try {
        const response = await ApiService.sendChatMessage(null, userMessage);
        if (!Array.isArray(response?.resized_list) || response.resized_list.length === 0) return;
        let labels = response["resized_list"];
        console.log('AI 분석 결과:', labels);
        this.chart = this.flattenArray(labels, 60, 40);
        if (this.ours) {
        this.printPixels();}
        this.translate(response['type']);  
        let assistant_result = response["text"];
        console.log('assistant_result 분석 결과:', assistant_result);
        this.addMessage('assistant', assistant_result, this.chart);
      } catch (e) {
        console.error('AI 요청 실패:', e);
         this.playDoneThenSpeak("질문에 대한 정보 추출에 실패 했습니다. 다시 시도해주세요.");
      } finally {
        this.chatLoading = false;
      }
    },

    askQuestion(question) { this.currentMessage = question; this.sendMessage(); },

    addMessage(type, content, labels = null) {
      const message = { id: this.messageIdCounter++, type, content, labels, timestamp: new Date() };
      this.chatMessages.push(message);
      if (this.ttsEnabled && type === 'assistant' && content) speakText(content, this.rate);
      this.$nextTick(() => { const el = this.$refs.chatMessages; if (el) el.scrollTop = el.scrollHeight; });
    },

    // === TTS & mode ===
    toggleTTS() { this.ttsEnabled = !this.ttsEnabled; if (!this.ttsEnabled) stopSpeaking(); },
    selectOurs() { this.ours = true; localStorage.setItem('oursBaselineState', 'ours'); },
    selectBaseline() { this.ours = false; localStorage.setItem('oursBaselineState', 'baseline'); this.playBaseline(); },
    loadOursBaselineState() { const saved = localStorage.getItem('oursBaselineState'); if (saved) this.ours = saved === 'ours'; },
    selectRate(num) { this.rate = num; localStorage.setItem('ttsRateState', num.toString()); },
    loadRateState() { const s = localStorage.getItem('ttsRateState'); if (s) { const n = parseInt(s); if ([2,5,8,12,15].includes(n)) this.rate = n; } },

    async playBaseline() {
      try {
        const key = this.textData?.name || 'default';
        const data = await import(`@/assets/json/${key}.json`);
        this.gridData = data.default;
        this.chart = this.flattenArray(this.gridData, 60, 40);
        this.printPixels();
      } catch (e) { console.error('JSON 로드 실패:', e); this.cleanupAudioTTS(); }
    },

    playAnalysisTTS() {
      if (!this.textData.analyzed) return;
      if (this.ours && this.textData.data) { this.chart = this.textData.data; this.printPixels(); }
      this.playDoneThenSpeak(this.textData.analyzed);
    },
    playRagIdTTS() {
      if (!this.textData.id) return;
      this.playDoneThenSpeak(this.textData.id);
    },
    playChatTTS(message) {
      if (!(message && message.type === 'assistant' && message.content)) return;
      if (message.labels && this.ours) { this.chart = message.labels; this.printPixels(); }
      this.playDoneThenSpeak(message.content);
    },

    // === Routing ===
    goBack() { this.cleanupAudioTTS(); this.$router.push('/'); },

    // === Utils ===
    formatSize(bytes) { if (bytes === 0) return '0 Bytes'; const k = 1024, units = ['Bytes','KB','MB','GB'], i = Math.floor(Math.log(bytes)/Math.log(k)); return `${parseFloat((bytes/Math.pow(k,i)).toFixed(2))} ${units[i]}`; },
    formatTime(date) { return date.toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' }); },
    toggleJsonExpanded() { this.jsonExpanded = !this.jsonExpanded; },
    formatAnalysisData(data) { if (!data) return '분석 데이터가 없습니다.'; try { return (typeof data === 'string') ? data : JSON.stringify(data, null, 2); } catch { return '데이터 포맷 오류'; } },

    // === STT shortcuts ===
    handleSpaceDown(e) { if (e.code==='Space' && !this.isListening && !this.chatLoading) { e.preventDefault(); this.startListening(); } },
    handleSpaceUp(e) { if (e.code==='Space' && this.isListening) { e.preventDefault(); this.stopListening(); } },
    handleCtrlShiftDown(e) { if (e.ctrlKey && e.shiftKey && !this.isListening && !this.chatLoading) { e.preventDefault(); this.startListening(); } },
    handleCtrlShiftUp(e) { if (this.isListening) { e.preventDefault(); this.stopListening(); } },

    async startListening() {
      if (this.isListening || this.chatLoading) return;
      try {
        this.isListening = true; this.sttError = null; this.transcription = ''; this.realTimeResults = [];
        const stream = await WhisperService.getMicrophoneStream();
        this.streamController = await WhisperService.transcribeStream(
          stream,
          (result, error) => {
            if (error) { this.sttError = '음성 변환 오류: ' + (error.message || error); return; }
            let text = '';
            if (typeof result === 'string') text = result; else if (result && typeof result.text === 'string') text = result.text;
            if (text && text.trim()) {
              if (!Array.isArray(this.realTimeResults)) this.realTimeResults = [];
              this.realTimeResults.push(text);
              this.transcription = this.realTimeResults.join(' ');
              this.currentMessage = text.trim();
              this.sendMessage();
            }
          },
          { language: 'korean', chunkInterval: 1000 }
        );
      } catch (err) { this.sttError = '녹음 시작 오류: ' + (err.message || err); this.isListening = false; }
    },

    async stopListening() {
      try { await this.streamController?.stop?.(); } catch {}
      finally { this.streamController = null; this.isListening = false; }
      const finalText = (this.realTimeResults || []).join(' ').replace(/\s+/g,' ').trim();
      this.realTimeResults = []; this.transcription = '';
      if (finalText) this.sendMessage(finalText);
    },

    handleTTSShortcuts(e) {
      if (e.repeat) return;
      const tag = (e.target && e.target.tagName) ? e.target.tagName.toLowerCase() : '';
      if (['input','textarea'].includes(tag) || e.isComposing) return;
      switch (e.code) {
        case 'Escape': stopSpeaking(); break;
        case 'ArrowRight': e.preventDefault(); skipSentence(this.rate); break;
        case 'ArrowLeft': e.preventDefault(); replayPrevious(this.rate); break;
        case 'KeyS': e.preventDefault(); togglePlayPause(this.rate); break;
        default: break;
      }
    },

    // === MediaStream ===
    stopStream() { try { this.stream?.getTracks()?.forEach(t => t.stop()); } catch {}; this.stream = null; this.streamReady = false; },
    async startStream(deviceId) {
      this.stopStream();
      const constraints = deviceId ? { video: { deviceId: { exact: deviceId } }, audio: false } : { video: true, audio: false };
      try { const stream = await navigator.mediaDevices.getUserMedia(constraints); this.stream = stream; this.streamReady = true; await this.refreshDevices(); }
      catch (e) { console.error('getUserMedia 실패:', e); this.streamReady = false; }
    },
    async refreshDevices() {
      try { const all = await navigator.mediaDevices.enumerateDevices(); this.devices = all.filter(d => d.kind === 'videoinput'); if (!this.selectedDeviceId && this.devices.length) this.selectedDeviceId = this.devices[0].deviceId; }
      catch (e) { console.error('enumerateDevices 실패:', e); }
    },
    async restartWithDevice() { if (!this.selectedDeviceId) return; await this.startStream(this.selectedDeviceId); },

    // === Thinking sound (fade in/out) ===
    startThinkingSound() {
      try {
        if (!this.thinkingAudio) return;
        this._fadeToken++; const myToken = this._fadeToken;
        if (this._fadeRAF) cancelAnimationFrame(this._fadeRAF);
        this.thinkingAudio.currentTime = 0; this.setVolumeSafe(0);
        this.thinkingAudio.play().then(() => {
          const target = 0.08, dur = 180; const t0 = performance.now();
          const step = (now) => { if (myToken !== this._fadeToken) return; const p = Math.max(0, Math.min(1, (now - t0) / dur)); this.setVolumeSafe(target * p); if (p < 1) this._fadeRAF = requestAnimationFrame(step); };
          this._fadeRAF = requestAnimationFrame(step);
        }).catch(err => console.warn('🔇 thinking play blocked:', err));
      } catch {}
    },
    stopThinkingSound(playDoneChime = false) {
      try {
        if (!this.thinkingAudio) return;
        const start = this.thinkingAudio.volume; const dur = 200; const t0 = performance.now();
        if (this._fadeRAF) cancelAnimationFrame(this._fadeRAF);
        const step = (now) => { const p = Math.min(1, (now - t0) / dur); this.setVolumeSafe(start * (1 - p)); if (p < 1) { this._fadeRAF = requestAnimationFrame(step); } else { this.thinkingAudio.pause(); this.thinkingAudio.currentTime = 0; if (playDoneChime && this.doneAudio) { this.doneAudio.currentTime = 0; this.doneAudio.play().catch(()=>{}); } } };
        this._fadeRAF = requestAnimationFrame(step);
      } catch {}
    },
    stopThinkingImmediately() {
      try { this._fadeToken++; if (this._fadeRAF) cancelAnimationFrame(this._fadeRAF); this._fadeRAF = null; if (this.thinkingAudio) { this.thinkingAudio.pause(); this.thinkingAudio.currentTime = 0; this.thinkingAudio.volume = 0; } } catch {}
    },
    setVolumeSafe(val) { if (!this.thinkingAudio) return; const n = Number.isFinite(val) ? val : 0; const c = Math.max(0, Math.min(1, n)); this.thinkingAudio.volume = c; },

    // === Done chime → speak ===
    async playDoneThenSpeak(text) {
      try {
        this.stopThinkingImmediately();
        if (this.doneAudio) {
          this.doneAudio.currentTime = 0;
          await this.doneAudio.play().catch(() => {});
          await new Promise((res) => { const h = () => { this.doneAudio.removeEventListener('ended', h); res(); }; this.doneAudio.addEventListener('ended', h, { once: true }); setTimeout(res, 400); });
        }
      } catch {}
      if (text) speakText(text, this.rate);
    },

    // === Timers ===
    startTimer0() { if (this.timer0Running) return; this.elapsed0Ms=0; this.started0At=Date.now(); this.timer0Running=true; this.timer0Interval=setInterval(()=>{ this.elapsed0Ms=Date.now()-this.started0At },100); },
    stopTimer0() { if (!this.timer0Running) return; clearInterval(this.timer0Interval); this.timer0Interval=null; this.timer0Running=false; this.elapsed0Ms=Date.now()-(this.started0At||Date.now()); },
    resetTimer0() { if (this.timer0Interval) clearInterval(this.timer0Interval); this.timer0Running=false; this.elapsed0Ms=0; this.started0At=null; },

    startTimer1(){ if (this.timer1Running) return; this.elapsed1Ms=0; this.started1At=Date.now(); this.timer1Running=true; this.timer1Interval=setInterval(()=>{ this.elapsed1Ms=Date.now()-this.started1At },100); },
    stopTimer1(){ if (!this.timer1Running) return; clearInterval(this.timer1Interval); this.timer1Interval=null; this.timer1Running=false; this.elapsed1Ms=Date.now()-(this.started1At||Date.now()); this.sendTimerToServer(1,'종료'); },
    resetTimer1(){ if (this.timer1Interval) clearInterval(this.timer1Interval); this.timer1Running=false; this.elapsed1Ms=0; this.started1At=null; },
    async stopAndSendTimer1(){ await this.sendTimerToServer(1,'기록'); },

    startTimer2(){ if (this.timer2Running) return; this.elapsed2Ms=0; this.started2At=Date.now(); this.timer2Running=true; this.timer2Interval=setInterval(()=>{ this.elapsed2Ms=Date.now()-this.started2At },100); },
    stopTimer2(){ if (!this.timer2Running) return; clearInterval(this.timer2Interval); this.timer2Interval=null; this.timer2Running=false; this.elapsed2Ms=Date.now()-(this.started2At||Date.now()); this.sendTimerToServer(2,'종료'); },
    resetTimer2(){ if (this.timer2Interval) clearInterval(this.timer2Interval); this.timer2Running=false; this.elapsed2Ms=0; this.started2At=null; },
    async stopAndSendTimer2(){ await this.sendTimerToServer(2,'기록'); },

    async sendTimerToServer(timerNumber, action) {
      const ms = (timerNumber === 1) ? this.elapsed1Ms : this.elapsed2Ms;
      const seconds = Math.max(0, Math.round(ms / 1000));
      const payload = { step_name: `${timerNumber}`, timeSpent: seconds, request_id: localStorage.getItem('uuid') || null };
      try {
        await ApiService.sendTimer(payload);
        const formattedTime = timerNumber === 1 ? this.formattedTime1 : this.formattedTime2;
        this.addMessage('system', `문제 ${timerNumber} ${action}: ${formattedTime} - 서버로 전송 완료`);
      } catch (error) {
        console.error(`⏱️ 타이머 ${timerNumber} ${action} 실패:`, error);
        this.addMessage('system', `타이머 ${timerNumber} ${action} 전송에 실패했습니다.`);
      }
    },

    // === Helpers ===
    flattenArray(originalArray, targetWidth, targetHeight) {
      if (!Array.isArray(originalArray) || originalArray.length === 0) return new Array(targetWidth * targetHeight).fill(0);
      const flattenedArray = new Array(targetWidth * targetHeight).fill(0);
      const inputWidth = originalArray[0].length; const inputHeight = originalArray.length;
      const startX = Math.floor((targetWidth - inputWidth) / 2); const startY = Math.floor((targetHeight - inputHeight) / 2);
      for (let y = 0; y < inputHeight; y++) { for (let x = 0; x < inputWidth; x++) { const index = (startY + y) * targetWidth + (startX + x); flattenedArray[index] = originalArray[y][x]; } }
      return flattenedArray;
    },

    loadTextData() {
      const q = this.$route.query;
      this.textData = {
        id: q.id || '',
        rId: q.rId || '',
        objectType: q.objectType || '',
        file: q.file || '',
        name: q.name || '',
        size: q.size ? parseInt(q.size) : null,
        data: null,
        isUploaded: q.isUploaded === 'true',
        isAnalyzed: q.isAnalyzed === 'true',
        analyzed: q.analyzed ? JSON.parse(q.analyzed) : null,
        ctrlDown: false,
        shiftDown: false,
        text: q.text || ''
      };
      const v = q.ours_or_baseline; if (v !== undefined) this.ours = (v === true || v === 'true' || v === '1');
      console.log('📋 QADetail에서 받은 데이터:', this.textData);
    },

    async handleQAUpload() {
        const text = this.tx
        console.log('textData 속성:', text )
         try {

          this.$router.push({
            name: 'QADetail',
            query: { 
              text: text, 
              isUploaded: false,
              isAnalyzed: false,
              ours_or_baseline: this.ours ? '1' : '0'
            }
          })
      } catch (aiError) {
            console.error('❌ AI 분석 실패:', aiError);

      }
    
    }
  }
};
</script>


<style scoped>
.image-detail {
  height: 100vh;
  background: #f4f7fc;
  display: flex;
  flex-direction: column;
}

.detail-header {
  background: white;
  padding: 0.75rem 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  flex-shrink: 0;
  z-index: 100;
}

.back-btn {
  background: #eef2f7;
  color: #333;
  border: 1px solid #dce4f0;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.back-btn:hover {
  background: #e1e8f2;
  border-color: #cdd7e5;
}

.detail-header h1 {
  color: #2c3e50;
  margin: 0;
  font-size: 1.5rem;
}

.detail-content {
  display: grid;
  grid-template-columns: minmax(400px, 1fr) 2fr;
  gap: 1.5rem;
  padding: 1.5rem;
  flex-grow: 1;
  overflow: hidden;
}

/* 좌측 이미지 섹션 */
.image-section {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.image-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.image-wrapper {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
  overflow: hidden;
  border-radius: 8px;
  background: #f8f9fa;
}

.main-image {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  object-position: center;
  border-radius: 8px;
  transition: transform 0.3s ease;
}

.main-image:hover {
  transform: scale(1.02);
}

.image-info {
  margin-top: auto;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  flex-shrink: 0;
}

.image-info h3 {
  margin: 0 0 0.5rem 0;
  color: #2c3e50;
  font-size: 1rem;
  font-weight: 600;
}

.image-info p {
  margin: 0.25rem 0;
  color: #6c757d;
  font-size: 0.85rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* ImageData 상세 정보 스타일 */
.imagedata-details {
  margin-top: 1rem;
  padding: 1rem;
  background: white;
  border-radius: 8px;
  border: 1px solid #e3f2fd;
}

.imagedata-details h4 {
  margin: 0 0 0.75rem 0;
  color: #2c3e50;
  font-size: 0.9rem;
  font-weight: 600;
}

/* 우측 분석 섹션 */
.analysis-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 100%;
  min-height: 0; /* Flex 아이템이 넘칠 때 축소되도록 허용 */
}

.analysis-panel {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  flex-shrink: 0;
  overflow-y: auto;
  max-height: 45%; /* 높이 비율 조정 */
}

.analysis-panel h3 {
  margin: 0 0 1rem 0;
  color: #2c3e50;
  font-size: 1.1rem;
}

.loading {
  text-align: center;
  color: #7f8c8d;
  padding: 2rem;
}

.analysis-results {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.analysis-item strong {
  color: #2c3e50;
  display: block;
  margin-bottom: 0.5rem;
}

.analysis-item ul {
  margin: 0;
  padding-left: 1.5rem;
  color: #555;
}

.color-palette {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.color-swatch {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px solid #ddd;
  cursor: pointer;
}

/* 채팅 패널 */
.chat-panel {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}

.chat-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.chat-panel h3 {
  margin: 0;
  color: #2c3e50;
  font-size: 1.1rem;
}

.chat-messages {
  flex-grow: 1;
  overflow-y: auto;
  margin-bottom: 1rem;
  padding: 0.5rem;
  background: #f8f9fa;
  border-radius: 8px;
  scrollbar-width: thin;
  scrollbar-color: #dce4f0 #f8f9fa;
}

.chat-messages::-webkit-scrollbar {
  width: 10px;
}

.chat-messages::-webkit-scrollbar-track {
  background: #f1f3f4;
  border-radius: 5px;
  margin: 5px;
}

.chat-messages::-webkit-scrollbar-thumb {
  background: #c1c7cd;
  border-radius: 5px;
  border: 2px solid #f1f3f4;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
  background: #9aa0a6;
}

.message {
  margin-bottom: 1rem;
  padding: 0.75rem;
  border-radius: 12px;
  max-width: 85%;
  word-wrap: break-word;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.message.user {
  background: #3b82f6;
  color: white;
  margin-left: auto;
  text-align: right;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);
}

.message.assistant {
  background: #eef2f7;
  color: #333;
  border: 1px solid #e2e8f0;
  box-shadow: none;
}

.message.system {
  background: #e8f5e8;
  color: #2d5016;
  border: 1px solid #c3e6c3;
  font-style: italic;
  max-width: 100%;
  text-align: center;
}

.empty-chat-message {
  text-align: center;
  color: #6c757d;
  font-size: 0.9rem;
  padding: 2rem;
  line-height: 1.6;
  background: #f8f9fa;
  border: 2px dashed #dee2e6;
  border-radius: 12px;
  margin: 1rem 0;
}

.message-content {
  margin-bottom: 0.25rem;
}

.message-time {
  font-size: 0.75rem;
  opacity: 0.7;
}

.chat-input-area {
  flex-shrink: 0; /* 입력 영역은 줄어들지 않도록 설정 */
  padding-top: 1rem;
  border-top: 1px solid #e9ecef;
}

.input-container {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.chat-input {
  flex: 1;
  padding: 0.75rem 1rem;
  border: 1px solid #dce4f0;
  border-radius: 8px;
  font-size: 0.9rem;
  transition: all 0.2s ease;
  background: white;
  resize: none;
}

.chat-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.send-btn {
  background: #3b82f6;
  color: white;
  border: none;
  padding: 0.75rem 1.25rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.send-btn:hover:not(:disabled) {
  background: #2563eb;
}

.send-btn:disabled {
  background: #bdc3c7;
  cursor: not-allowed;
}

.suggested-questions {
  margin-bottom: 1rem;
  flex-shrink: 0;
}

.suggested-questions p {
  margin: 0 0 0.5rem 0;
  font-size: 0.9rem;
  color: #495057;
  font-weight: 600;
  text-align: left;
}

.suggested-questions-container {
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  padding: 0.25rem 0;
  scrollbar-width: thin;
  scrollbar-color: #bdc3c7 #ecf0f1;
}

.suggested-questions-container::-webkit-scrollbar {
  height: 6px;
}

.suggested-questions-container::-webkit-scrollbar-track {
  background: #ecf0f1;
  border-radius: 3px;
}

.suggested-questions-container::-webkit-scrollbar-thumb {
  background: #bdc3c7;
  border-radius: 3px;
}

.suggestion-btn {
  background: #eef2f7;
  color: #4a5568;
  border: 1px solid #e2e8f0;
  padding: 0.5rem 1rem;
  border-radius: 16px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 500;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.suggestion-btn:hover {
  background: #e2e8f0;
  border-color: #dce4f0;
  color: #2d3748;
}

/* 반응형 */
/* 반응형 디자인 */
@media (max-width: 1200px) {
  .detail-content {
    grid-template-columns: 450px 1fr;
    gap: 1rem;
  }
}

@media (max-width: 1024px) {
  .detail-content {
    grid-template-columns: 1fr;
    height: auto;
    padding: 1rem;
  }
  
  .image-section {
    order: 1;
    margin-bottom: 1rem;
    height: auto; /* 높이 자동 조정 */
  }
  
  .analysis-section {
    order: 2;
    height: auto; /* 높이 자동 조정 */
  }
  
  .image-wrapper {
    max-height: 50vh; /* 화면 높이에 비례하여 조정 */
  }
  
  .timer-container {
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .timer-section {
    min-width: auto;
  }
  
  .chat-panel {
    height: 60vh; /* 화면 높이에 비례하여 조정 */
  }
}

/* 새로운 ImageData 관련 스타일 */
.analysis-status {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
  align-items: center;
}

.analysis-status:first-child {
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
}

.status-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 500;
  background: #f8f9fa;
  color: #6c757d;
}

.status-badge.uploaded {
  background: #d4edda;
  color: #155724;
}

.status-badge.analyzed {
  background: #e2e3f7;
  color: #383d41;
}

/* imagedata-info 스타일 제거됨 - imagedata-details로 통합 */

.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}

.info-item {
  padding: 0.5rem;
  background: white;
  border-radius: 4px;
  font-size: 0.9rem;
}

.ai-analysis {
  margin-bottom: 1.5rem;
}

.analysis-json-container {
  position: relative;
}

.json-toggle-btn {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: #4a5568;
  color: white;
  border: none;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  font-size: 0.8rem;
  cursor: pointer;
  z-index: 1;
  transition: background 0.3s ease;
}

.json-toggle-btn:hover {
  background: #2d3748;
}

.analysis-json {
  background: #2d3748;
  color: #e2e8f0;
  padding: 1rem;
  padding-top: 2.5rem;
  border-radius: 8px;
  font-size: 0.8rem;
  overflow-x: auto;
  white-space: pre-wrap;
  max-height: 200px;
  overflow-y: auto;
  line-height: 1.4;
  transition: max-height 0.3s ease;
}

.analysis-json.expanded {
  max-height: 600px;
}

@media (max-width: 768px) {
  .detail-header {
    padding: 1rem;
  }
  
  .detail-content {
    padding: 0.75rem;
    gap: 0.75rem;
  }
  
  .analysis-panel,
  .chat-panel {
    padding: 1rem;
  }
  
  .analysis-status {
    flex-direction: column;
    align-items: stretch;
  }
  
  .status-btn {
    margin-right: 0;
    margin-bottom: 0.5rem;
  }
  
  .timer-container {
    padding: 0.5rem;
  }
  
  .timer-section {
    margin-bottom: 0.5rem;
  }
  
  .timer-section-wrapper {
    padding: 0.75rem;
    margin: 0.5rem 0;
  }
  
  .timer-section-title {
    font-size: 0.9rem;
  }
  
  .chat-messages {
    min-height: 150px;
    max-height: 250px;
  }
  
  .chat-panel {
    min-height: 400px;
    height: auto;
  }
  
  .chat-input-area {
    position: sticky;
    bottom: 0;
    background: white;
    border-top: 2px solid #e9ecef;
    padding: 1rem;
    margin: 0;
  }
  
  .suggested-questions {
    padding: 0.75rem;
    margin-top: 0.5rem;
  }
  
  .suggested-questions-container {
    gap: 0.3rem;
  }
  
  .suggestion-btn {
    padding: 0.5rem 0.8rem;
    font-size: 0.8rem;
  }
  
  .info-grid {
    grid-template-columns: 1fr;
  }
  
  .model-toggle-container {
    flex-direction: column;
    gap: 0.75rem;
    align-items: center;
  }
  
  .toggle-label {
    text-align: center;
  }
  
  .toggle-switch-wrapper {
    width: 100%;
    max-width: 250px;
  }
  
  /* 좌우배치 컨테이너 반응형 */
  .controls-horizontal-container {
    flex-direction: column;
    gap: 0.75rem;
    margin: 0.75rem 0;
  }
  
  /* TTS Rate 반응형 스타일 */
  .tts-rate-wrapper {
    padding: 1rem;
    margin: 0;
    flex: none;
  }
  
  .tts-rate-title {
    font-size: 0.9rem;
    padding-bottom: 0.5rem;
  }
  
  .tts-rate-container {
    flex-direction: row;
    gap: 0.75rem;
    align-items: center;
    justify-content: center;
  }
  
  .rate-label {
    text-align: center;
    font-size: 0.85rem;
  }
  
  .rate-buttons-wrapper {
    gap: 0.4rem;
    justify-content: center;
  }
  
  .rate-btn {
    width: 40px;
    height: 40px;
    font-size: 0.8rem;
  }
  
  .rate-btn:hover {
    transform: translateY(-1px) scale(1.03);
  }
  
  .rate-btn.active {
    transform: scale(1.05);
  }
  
  /* 모델 선택 반응형 스타일 */
  .model-selection-wrapper {
    margin: 0;
    flex: none;
  }
}

.stt-indicator {
  background: #e3f2fd;
  color: #1976d2;
  padding: 8px 16px;
  border-radius: 8px;
  margin-bottom: 8px;
  font-weight: bold;
  text-align: center;
}
.error {
  background: #ffebee;
  color: #c62828;
  padding: 8px 16px;
  border-radius: 8px;
  margin-bottom: 8px;
  text-align: center;
}

.tts-toggle-btn {
  background: #f1f3f4;
  color: #2c3e50;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background 0.3s ease;
  align-self: flex-start;
}

.tts-toggle-btn:hover {
  background: #e2e6ea;
}

/* 기존 status-btn은 다른 용도로 유지 */
.status-btn {
  background: #3498db;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  margin-right: 0.5rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.3s ease;
  min-width: 60px;
  text-align: center;
}

.status-btn:hover {
  background: #2980b9;
  transform: translateY(-1px);
}

.status-btn.active {
  background: #2ecc71;
  box-shadow: 0 2px 8px rgba(46, 204, 113, 0.3);
}

/* 좌우배치 컨테이너 */
.controls-horizontal-container {
  display: flex;
  gap: 0.75rem;
  align-items: stretch;
  margin: 0.75rem 0;
}

/* TTS 속도 선택 영역 스타일 */
.tts-rate-wrapper {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: 1px solid #e3f2fd;
  border-radius: 12px;
  padding: 0.75rem;
  margin: 0;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.15);
  flex: 1;
}

.tts-rate-title {
  margin: 0 0 0.5rem 0;
  color: white;
  font-size: 0.9rem;
  font-weight: 700;
  text-align: center;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 0.4rem;
}

.tts-rate-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  flex-wrap: wrap;
  flex-direction: row;
}

.rate-label {
  font-size: 0.95rem;
  font-weight: 600;
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  min-width: fit-content;
}

.rate-buttons-wrapper {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: center;
}

.rate-btn {
  background: rgba(255, 255, 255, 0.9);
  color: #4a5568;
  border: 2px solid rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  width: 45px;
  height: 45px;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
}

.rate-btn:hover {
  background: white;
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  border-color: #3b82f6;
}

.rate-btn.active {
  background: #3b82f6;
  color: white;
  border-color: #2563eb;
  transform: translateY(-1px) scale(1.1);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
  animation: pulse-rate 1.5s ease-in-out infinite alternate;
}

@keyframes pulse-rate {
  from { 
    box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
  }
  to { 
    box-shadow: 0 8px 25px rgba(59, 130, 246, 0.6);
  }
}

/* 모델 선택 영역 스타일 */
.model-selection-wrapper {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 0.75rem;
  margin: 0;
  flex: 1;
}

.model-selection-title {
  margin: 0 0 0.5rem 0;
  color: #495057;
  font-size: 0.9rem;
  font-weight: 600;
  text-align: center;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 0.4rem;
}

.model-toggle-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  flex-wrap: wrap;
}

.toggle-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #495057;
  min-width: fit-content;
}

.toggle-switch-wrapper {
  display: flex;
  background: #e9ecef;
  border-radius: 25px;
  padding: 3px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.toggle-option {
  border: none;
  background: transparent;
  color: #6c757d;
  padding: 0.5rem 1.25rem;
  border-radius: 22px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;
  min-width: 80px;
  text-align: center;
}

.toggle-option:hover {
  color: #495057;
}

.toggle-option.active {
  background: #3b82f6;
  color: white;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
  transform: translateY(-1px);
}

.toggle-option:first-child.active {
  background: #10b981;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
}

.toggle-option:last-child.active {
  background: #f59e0b;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);
}

/* 타이머 섹션 래퍼 */
.timer-section-wrapper {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 0.75rem;
  margin: 0.75rem 0;
}

.timer-section-title {
  margin: 0 0 0.5rem 0;
  color: #495057;
  font-size: 0.9rem;
  font-weight: 600;
  text-align: center;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 0.4rem;
}

/* 타이머 스타일 */
.timer-container {
  display: flex;
  gap: 0.6rem;
  background: white;
  border: 1px solid #e3f2fd;
  border-radius: 8px;
  padding: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  flex-wrap: wrap;
}

.timer-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  flex: 1;
  min-width: 120px;
}

.timer-label {
  font-size: 0.8rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 0.3rem;
  text-align: center;
}

.timer-display {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  margin-bottom: 0.3rem;
}

.timer-icon {
  font-size: 1rem;
}

.timer-time {
  font-size: 1rem;
  font-weight: bold;
  color: #2c3e50;
  font-family: 'Monaco', 'Consolas', monospace;
  min-width: 50px;
  text-align: center;
}

.timer-status {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #bdc3c7;
  transition: all 0.3s ease;
}

.timer-status.running {
  background: #e74c3c;
  animation: pulse 1.5s ease-in-out infinite alternate;
}

@keyframes pulse {
  from { opacity: 1; }
  to { opacity: 0.5; }
}

.timer-controls {
  display: flex;
  gap: 0.3rem;
  flex-wrap: wrap;
  justify-content: center;
}

.timer-btn {
  border: 1px solid #dce4f0;
  border-radius: 6px;
  padding: 0.25rem 0.5rem;
  font-size: 0.7rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  background: white;
  color: #333;
}

.timer-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #f8f9fa;
}

.start-btn {
  background: #e3f2fd;
  border-color: #bbdefb;
  color: #1e88e5;
}

.start-btn:hover:not(:disabled) {
  background: #dbeffd;
}

.record-btn {
  background: #e8f5e9;
  border-color: #c8e6c9;
  color: #388e3c;
}

.record-btn:hover:not(:disabled) {
  background: #ddf2de;
}

.stop-btn {
  background: #fff3e0;
  border-color: #ffcc80;
  color: #ef6c00;
}

.stop-btn:hover:not(:disabled) {
  background: #ffecc1;
}

.reset-btn {
   background: #fbe9e7;
  border-color: #ffccbc;
  color: #d84315;
}

.reset-btn:hover:not(:disabled) {
  background: #f9e2de;
}

.ws-row { display:flex; gap:12px; flex-wrap:wrap; margin-bottom:12px; }
.ws-col { flex:1 1 320px; background:#f8f9fa; border:1px solid #e9ecef; border-radius:12px; padding:10px; }
.ws-title { margin:0 0 8px 0; font-size:.95rem; color:#2c3e50; }
.ws-frame { position:relative; background:white; border:1px solid #e3f2fd; border-radius:8px; min-height:180px; display:flex; align-items:center; justify-content:center; overflow:hidden; }
.ws-img { max-width:100%; max-height:320px; }
.ws-empty { color:#9aa0a6; font-size:.9rem; padding:20px; }
.ws-fps { position:absolute; top:8px; right:8px; font-size:.75rem; background:rgba(0,0,0,.7); color:#fff; padding:2px 6px; border-radius:6px; }
.ws-stats { margin-top:6px; display:flex; gap:8px; flex-wrap:wrap; font-size:.85rem; color:#4a5568; }

.header-actions {
  margin-left: auto;               /* 우측 정렬 */
  display: flex;
  align-items: center;
  gap: 8px;
}

.ws-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 12px;
  background: #f5f7fb;
  border: 1px solid #e5e9f2;
  font-size: 12px;
  color: #475569;
}

.ws-indicator .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #cbd5e1;            /* 기본: 회색(해제) */
  box-shadow: 0 0 0 2px rgba(0,0,0,0.04) inset;
}

.ws-indicator.on .dot {
  background: #22c55e;            /* 연결: 초록 */
}

.connect-btn {
  font-size: 12px;
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid #dce4f0;
  background: #ffffff;
  color: #334155;
  cursor: pointer;
  transition: background .2s, transform .05s;
}

.connect-btn:hover { background: #f8fafc; }
.connect-btn:active { transform: translateY(1px); }

.user-input-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.input-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.input-group label {
  font-weight: 600;
  color: #34495e;
  min-width: 80px;
}

.user-input {
  flex: 1;
  padding: 0.75rem;
  border: 2px solid #e3f2fd;
  border-radius: 8px;
  font-size: 1rem;
  min-width: 200px;
  transition: border-color 0.3s ease;
}

.user-input:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
}

</style>


